import { useTranslations } from '@/i18n/context';

const BG_IMAGES = [
  '/images/spring.jpg',
  '/images/summer.jpg',
  '/images/autumn.jpg',
  '/images/winter.jpg',
];

export function Scenarios() {
  const t = useTranslations('scenarios');
  const items = t.raw('items') as Array<{
    title: string;
    solution: string;
    body: string;
  }>;

  return (
    <section
      id="scenarios"
      className="relative bg-[color:var(--mp-cream)] py-24 md:py-40"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-20">
        <div className="mb-16 grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="mb-4 text-[11px] uppercase tracking-[0.32em] text-[color:var(--mp-moss)]">
              {t('sectionLabel')}
            </div>
            <h2
              className="font-serif-cn text-4xl leading-[1.2] text-[color:var(--mp-forest)] md:text-6xl"
              // eslint-disable-next-line react/no-danger -- trusted translation
              dangerouslySetInnerHTML={{ __html: t('title') }}
            />
          </div>
          <div className="md:col-span-5 md:col-start-8 md:pt-6">
            <p className="text-[15px] leading-[2] text-[color:var(--mp-forest)]/70">
              {t('intro')}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2">
          {items.map((s, i) => (
            <div
              key={s.title}
              className={`group relative overflow-hidden border-t hairline p-8 transition-colors md:p-12 ${
                i % 2 === 0 ? 'md:border-r hairline' : ''
              } ${i >= items.length - 2 ? 'md:last:border-b hairline' : ''}`}
            >
              {/* 背景图片 */}
              <div
                className="absolute inset-0 z-0 opacity-90 transition-opacity group-hover:opacity-100"
                style={{
                  backgroundImage: `url(${BG_IMAGES[i]})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              />
              {/* 渐变遮罩 */}
              <div className="absolute inset-0 z-0 bg-gradient-to-br from-[color:var(--mp-cream)] via-[color:var(--mp-cream)]/90 to-transparent" />

              {/* 内容 */}
              <div className="relative z-10">
                <div className="flex items-baseline justify-between gap-6">
                  <h3 className="font-serif-cn text-2xl leading-[1.3] text-[color:var(--mp-forest)] md:text-3xl">
                    {s.title}
                  </h3>
                  <span className="font-display shrink-0 text-sm italic text-[color:var(--mp-caramel)]">
                    0{i + 1}
                  </span>
                </div>
                <div className="mt-4 inline-flex items-center gap-2 border hairline bg-[color:var(--mp-cream)]/80 px-3 py-1 text-[10px] uppercase tracking-[0.22em] text-[color:var(--mp-moss)]">
                  <span className="h-1 w-1 rounded-full bg-[color:var(--mp-moss)]" />
                  {s.solution}
                </div>
                <p className="mt-6 text-[15px] leading-[1.9] text-[color:var(--mp-forest)]/75">
                  {s.body}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-24 grid grid-cols-1 gap-4 md:grid-cols-3">
          <div className="md:col-span-2">
            <img
              src="https://img.alicdn.com/imgextra/i1/2216742298660/O1CN01opAPY82DqL5QUcevS_!!2216742298660.jpg"
              alt="森林山径漫步"
              className="aspect-[16/10] w-full object-cover"
            />
          </div>
          <div className="flex flex-col justify-end bg-[color:var(--mp-moss)] p-8 text-[color:var(--mp-cream)] md:p-10">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[color:var(--mp-signal)]">
              {t('editorsNote')}
            </div>
            <p className="font-serif-cn mt-4 text-lg leading-[1.9]">
              {t('editorsQuote')}
            </p>
            <div className="mt-6 text-[11px] uppercase tracking-[0.22em] text-[color:var(--mp-cream)]/70">
              {t('editorsTeam')}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
